import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class ScribbleIn {

	constructor() {
		this.elements = document.querySelectorAll('[data-scribble-in]');
	}

	init() {
		this.elements.forEach(el => this.setup(el));
	}

	setup(el) {
		const paths = el.querySelectorAll('path');
		if (!paths.length) return;

		// Prime each path: set dasharray to full length, dashoffset to full length (hidden)
		paths.forEach(path => {
			const length = path.getTotalLength();
			path.style.strokeDasharray = length;
			path.style.strokeDashoffset = length;
		});

		ScrollTrigger.create({
			trigger: el,
			start: 'top 75%',
			once: true,
			onEnter: () => {
				gsap.to(paths, {
					strokeDashoffset: 0,
					duration: 1.0,
					ease: 'power2.out',
					stagger: 0.08,
				});
			},
		});
	}

}

export default ScribbleIn;
